import { Currency } from '@/core/currency/interfaces';

const NZD: Currency = {
    name: 'New Zealand Dollar',
    demonym: 'New Zealand',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '554',
    symbol: 'NZ$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'NZD',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default NZD;
